import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[ogsItem]',
  standalone: true
})
export class OgsItemDirective {
  public templateRef: TemplateRef<unknown> = inject(TemplateRef<unknown>);
}
